import { GA_GENERAL_CATEGORY, GA_GENERAL_EVENTS, GA_GENERAL_POPUPS_SOURCES } from 'modules/ga/generalEvents';
import { setPopup } from 'modules/popup/actions';
import app from 'new-ui/app';
import { POPUP, POPUPS } from 'utils/constants/popup';

export const answerQuestionAction = ({
  question, answer, toastText, redirectPopup,
}) => async (dispatch) => {
  await app.answerQuestion({ [question]: answer });

  if (toastText) {
    app.alert({ content: toastText });
  }
  if (redirectPopup && POPUPS.includes(redirectPopup)) {
    dispatch(setPopup({ type: redirectPopup }));
  }
};

export const showUrlPopupAction = ({ type, data }) => (dispatch, getState) => {
  const { popup: { popup } } = getState();
  if (popup) {
    return;
  }
  window.Intercom('hide');

  const { source } = data;
  app.sendGoogleAnalyticsEvent(
    GA_GENERAL_CATEGORY,
    GA_GENERAL_EVENTS.POPUP_OPEN,
    { popup: type, source: GA_GENERAL_POPUPS_SOURCES.URL, data: source },
  );

  dispatch(setPopup({ type, data }));
};

export const questionToAskAction = ({ question }) => (dispatch) => {
  app.editQuestion([question], async ({ notFound }) => {
    if (notFound) {
      // should be invariant
      console.error(`${question} question is not found`);
      app.setPopup(false);
      dispatch(setPopup(false));
      return;
    }

    dispatch(setPopup({
      type: POPUP.MEDICAL_PROFILE,
      data: {
        highlight: question,
        scrollTop: 0,
      },
    }));

    await app.requestRematch();
  });
};

export const questionsToAskAction = ({ questions }) => (dispatch) => {
  dispatch(setPopup({
    type: POPUP.QUESTIONS,
    data: { questions },
  }));
};

export const unsubscribeFormAction = () => (dispatch) => {
  dispatch(setPopup({ type: POPUP.UNSUBSCRIBE_FORM }));
};
